import React from "react";
import Select from "react-select";

const EmploymentStatusSelect = ({ value, onChange, isMulti = false }) => {
  const options = [
    { value: 'active', label: "Active" },
    { value: 'probation', label: "Probation" },
    { value: 'terminated', label: "Terminated" },
    { value: 'resigned', label: "Resigned" },
    { value: 'relieved', label: "Relieved" },
  ];



  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: '#f9f9f9', // Apply background color
      borderColor: '#ddd', // Apply border color
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999, // Ensure dropdown appears above other elements
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#666666', // Customize placeholder color
    }),
  };
  
  // Handle change differently based on isMulti
  const handleChange = (selectedOption) => {
    if (isMulti) {
      onChange(selectedOption ? selectedOption.map(option => ({ value: option.value, label: option.label })) : []);
    } else {
      onChange(selectedOption ? { value: selectedOption.value, label: selectedOption.label } : null);
    }
  };

  return (
    <Select
      options={options}
      placeholder="Select Status"
      value={
        isMulti
          ? value && Array.isArray(value) ? value.map(val => options.find(option => option.value === val.value)) : []
          : value ? options.find(option => option.value === value.value) || null : null
      }

      styles={customStyles}
      onChange={handleChange}

      isClearable
      isMulti={isMulti} // Enables multi-select if isMulti is true
    />
  );
};

export default EmploymentStatusSelect;
